import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Container } from "@material-ui/core";
import * as api from "../../api";
import {
  selectedTenacyType,
  saveCurrentAssetEligibilityDetails,
  saveSubSessionAssetsEligibilityDetails,
  workOrderRepairObject,
  saveIsEligibleForEnhancedDiagnostics,
  getContractorName,
  saveSupplimentaryCodes,
  dmcWorkOrderRepairObject
} from "../../ducks/redux/actions/getAddress";
import {
  userChosenSurveyReason,
  userChosenCovidQuestion,
  userChosenContactDetails,
  userChosenContactPhone,
  userChosenContactName,
  userChosenRelationDetails,
  isEditState,
  userChosenAdditionalDescription,
  userChosenVandalismQuestion,
  userChosenVandalismAdditionalInformation,
  userChosenVulnerabilityQuestion,
  userChosenVulnerabilityAdditionalInformation,
  userChosenDuplicateQuestion,
  userChosenEmergencyQuestion,
  userChosenRepairLocationId,
  userChosenHighLevelDescription,
  communalAssetwithNoHierarchy,
  repairAddressData,
  backToRepairAsset,
  userChosenDuplicateEntity,
  userChosenCurrentValue,
  userChosenPropertyId,
  userChosenSaveExit,
  userChoiceRepairReasons,
  userTypedSurveyReason,
  userChosenPropertyAddress,
  selectedTenancyGroup,
  resumeDraftRepair,
  userResumeDraftDataCache,
  saveIsEligibleTradeForED,
  setRepairDiagnosticFinalData,
  defaultAssetId,
  repairHistoryRedirectPage
} from "../../ducks/redux/actions/userChoices";
import {
  updateDashboardForm,
  userTypedRepairReasons,
  assetByIdDataObject,
  fetchRepairReasons,
  fetchRepairReasonsSelect,
  sorErrorCode,
  selectedRepairReasonPriorityOverride,
  selectedRepairReasonDefaultPriority
} from "../../ducks/redux/actions/dashboardReducer.actions";
import { RouteComponentProps } from "react-router-dom";
import Button from "../../Button/Button";
import ExitModalContent from "../Modal/ExitModalContent";
import { isUndefinedNullOrEmpty, isUndefinedNullOrEmptyForBoolean } from "../../utils/translation/helper";
import { finishJourney, removeAllDMCData, saveAssetSubTypeData, saveParentAssetTypeData } from "../../ducks/redux/actions/FinancialReferral";
import RepairJourney from "../RepairJourney";
import "../RepairJourney/index.css"
import { isNullOrUndefined } from "../../utils/formatting";
import { PermissionsList } from "../../models/Permissions";
import { Helper } from "../../utils/Helper/HelperUtil";
import LoadingSpinner from "../../storybook/LoadingSpinner";
import { PremisesTypeId } from "../../models/Customer/Premises";
import { resetHazardAssessmentData } from "../../ducks/redux/actions/hazardAssessment";

interface RepairAssetProps extends RouteComponentProps<any> { }

const RepairAsset: React.FC<RepairAssetProps> = (props) => {
  const assetDetails = useSelector(
    (state: any) => state?.dashboardReducer?.formState?.assetByIdDataObject
  );
  const assets = (state: any) => state?.addresses?.customerassociatedassets;
  const addressesData = useSelector(assets);
  const getPermissionsData = useSelector((state: any) => state?.userChoicesReducer?.userProfilePermissions);
  const isEnhancedDiagnosticsEnabled = useSelector((state: any) => state?.userChoicesReducer?.isEDEnabled);
  const accessEnhancedRepairDiagnostics = Helper.doesHavePermission(getPermissionsData, PermissionsList.access_enhanced_repair_diagnostics_journey);
  const selectedAssets = useSelector((state: any) => state?.userChoicesReducer?.repairAddressData?.[0]);
  const backValue = useSelector((state: any) => state?.userChoicesReducer?.backValue);
  const workOrders = useSelector((state: any) => state?.userChoicesReducer?.workOrderData);
  const isSurvey = useSelector((state: any) => state?.userChoicesReducer?.isSurvey);
  const EditState = useSelector((state: any) => state?.userChoicesReducer?.isEditState);
  const isEligibleForEnhancedDiagnostics = useSelector((state: any) => state?.addresses?.isEligibleForEnhancedDiagnostics);
  const customerTenancy = useSelector((state: any) => state?.addresses?.customertenancies);
  const IsRecall = useSelector((state: any) => state?.userChoicesReducer?.IsRecall);
  const customerID = useSelector((state: any) => state?.addresses?.customerid);
  const backToRepair = useSelector((state: any) => state?.userChoicesReducer?.backToRepairAsset);
  const isResumeDraftRepair = useSelector((state: any) => state?.userChoicesReducer?.resumeDraftRepair);
  const workOrderObject = useSelector((state: any) => state?.addresses?.workOrderRepair);
  const [isLoading, setIsLoading] = useState(true);
  let eligiblityForEnhancedDiagnostics: any = null;
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  const [addresses, setAddresses] = useState<any>();
  const [eligibilityWarningBoxStyle, setEligibilityWarningBoxStyle] = React.useState("none");
  const [errorCode, setErrorCode] = useState("");
  const [supplimentaryAlert, setSupplimentaryAlert] = useState([]);
  const [buttondisable, setButtonDisable] = useState(false);
  const [propertyIdChosen, setPropertyIdChosen] = useState("");
  const [isRecallValue, setIsRecallValue] = useState(false);
  const loadingTimeoutRef = useRef<NodeJS.Timeout | null>(null);
  let arrayErrorCode: string[] = [];
  let [errorCodeArray, setErrorCodeArray] = useState(arrayErrorCode);
  let [plentificRepairDiagnosticsHealth, setPlentificRepairDiagnosticsHealth] = useState<any>(null);


  let subSessionAssetsEligibilityDetailsRedux = useSelector(
    (state: any) => state?.addresses?.subSessionAssetsEligibilityDetails
  );
  //To track div selection for RepairProperty--Start here---
  const [assetTypeValue, setAssetTypeValue] = useState("");
  //-----------Ends here-----------//


  useEffect(() => {
    setIsLoading(true);
    setIsRecallValue(IsRecall ?? false)
    setPropertyIdChosen(assetDetails?.id);

    const currentSelectedAddressHierarchyList: any = Array.isArray(addressesData) ?
      addressesData.find((addressList: any) => addressList.filter((address: any) => address.id === assetDetails?.id)?.length > 0)
      : null;

    (async function () {
      try {
        dispatch(userChosenCurrentValue(null));
        dispatch(communalAssetwithNoHierarchy(false));
        dispatch(userChosenSaveExit(null));
        dispatch(userChosenDuplicateEntity(""));
        dispatch(saveIsEligibleTradeForED(false));
        dispatch(setRepairDiagnosticFinalData(null));
        if (!isUndefinedNullOrEmpty(currentSelectedAddressHierarchyList) && currentSelectedAddressHierarchyList.length < 1) {
          //Awaiting setup of currentSelectedAddressHierarchyList
        } else if (backToRepair && selectedAssets?.length > 0) {
          setAddresses([selectedAssets]);

          const matchedAsset = selectedAssets.find((x: any) => x.id === assetDetails?.id);
          if (matchedAsset) {
            await checkAndSetAssetDetailsForNextStep(
              matchedAsset.assetType,
              matchedAsset.id,
              matchedAsset.uprn,
              matchedAsset.addresses?.postalAddresses?.[0]?.formattedAddress
            );
          }

          setIsLoading(false);
        }
        else {
          //Coming from Raise a repair step
          const currentAsset = assetDetails;
          const assetTypeId = Number.parseInt(PremisesTypeId[currentAsset.assetType]);
          let addressSelectedDataList = currentSelectedAddressHierarchyList.filter(
            (x: any) => {
              const associatedAssetTypeId = Number.parseInt(PremisesTypeId[x.assetType]);
              //Selecting self and parents only. Ignoring schemes, cant raise repairs for them
              const isSelf = currentAsset.id === x.id;
              return (isSelf || associatedAssetTypeId < assetTypeId) && associatedAssetTypeId > PremisesTypeId["Scheme"];
            }
          );
          let filteredAddress: any = [];
          filteredAddress.push(addressSelectedDataList);
          dispatch(repairAddressData(filteredAddress));

          await checkAndSetAssetDetailsForNextStep(
            currentAsset?.assetType,
            currentAsset?.id,
            currentAsset?.uprn,
            currentAsset?.addresses?.postalAddresses[0]?.formattedAddress
          );

          if (
            currentSelectedAddressHierarchyList.length > 1 ||
            currentAsset?.assetType === "Property"
          ) {
            // Covering below logical scenarios:
            // length > 1 && !Property => Communal with hierarchy
            // length > 1 && Property => Property with hierarchy
            // length == 1 && Property => Property without hierarchy
            // Allow user to select asset from self and hierarchy, if user arrives here

            setAddresses(filteredAddress);
            setTimeout(() => setIsLoading(false), 300);
          } else {
            // Covering below logical scenarios:
            // length == 1 && !Property => Communal without hierarchy
            // We want user to skip to next page if Communal asset without any hierarchy after appropriate dispatches
            dispatch(communalAssetwithNoHierarchy(true));
            await redirectAfterEligibilityCheck();
          }
        }
      } catch (e) {
        SetRepairSectionUnavailable();
        console.error(e);
      }
    })();
  }, [props.location.pathname]);


  const resetRepairAssetStates = (isSurvey: boolean | undefined) => {
    // removing all dmc and hazard assessment data when user create new work order
    dispatch(resetHazardAssessmentData());
    dispatch(removeAllDMCData(null));
    dispatch(sorErrorCode(""));
    dispatch(backToRepairAsset(false));
    if (!(backToRepair && isResumeDraftRepair && workOrderObject?.premisesId === propertyIdChosen)) {
      dispatch(fetchRepairReasons([]));
      dispatch(fetchRepairReasonsSelect([]));
      dispatch(dmcWorkOrderRepairObject(null));
    }
    dispatch(selectedRepairReasonPriorityOverride(null));
    dispatch(selectedRepairReasonDefaultPriority(null));
    if (!(backToRepair && isResumeDraftRepair && workOrderObject?.premisesId === propertyIdChosen)) {
      dispatch(userResumeDraftDataCache(null));
    }
    if (isSurvey) {
      dispatch(userTypedRepairReasons(""));
      dispatch(userChoiceRepairReasons(""));
      dispatch(getContractorName(""));
      dispatch(userChosenAdditionalDescription(""));
      dispatch(userChosenEmergencyQuestion(""));
      dispatch(userTypedSurveyReason(""));
      dispatch(userChosenSurveyReason(""));
    }
  };

  const SetRepairSectionUnavailable = () => {
    // "We're sorry, our repair section is unavailable at the moment. Please try again later"
    setErrorCode("SSR001");
    setEligibilityWarningBoxStyle("block");
    setButtonDisable(true);
  };

  // Added to ensure eligibility data (eligiblityForEnhancedDiagnostics) is fully set before redirecting.
  // Earlier it was redirecting immediately without waiting for eligibility API response to complete.
  const redirectAfterEligibilityCheck = async () => {
    const checkAndRedirect = () => {
      if (isUndefinedNullOrEmptyForBoolean(eligiblityForEnhancedDiagnostics)) {
        setTimeout(checkAndRedirect, 200);
        return;
      }
      let redirectPath = "";
      resetRepairAssetStates(isSurvey);
      if (isSurvey) {
        redirectPath = "/SurveyLocation";
      } else if (eligiblityForEnhancedDiagnostics) {
        redirectPath = "/RepairTradeCategory";
      } else {
        redirectPath = "/RepairLocation";
      }
      props.history.push(redirectPath);
    };

    checkAndRedirect();
  };

  const backButtonHandler = () => {
    dispatch(backToRepairAsset(false));
    dispatch(finishJourney(true));
    props.history.push(Helper.BackRedirectMap[backValue] ?? `/WorkOrder360View/${workOrders?.identifiers?.worksOrderIdentifier}`);
  };


  const exitButtonHandler = () => {
    dispatch(backToRepairAsset(false));
    props.history.push("/LandingView");
  };

  const callPageHandler = () => {
    // Removing hazard assessment data
    resetRepairAssetStates(isSurvey);
    const previousPathname = (props?.history?.location?.state as any)?.previousPathname;
    if (previousPathname === "/CustomerWorkOrder" || previousPathname === "/Customer360View") {
      dispatch(repairHistoryRedirectPage("/CustomerWorkOrder"));
    }
    else {
      dispatch(repairHistoryRedirectPage("/AssetWorkOrderResult"));
    }

    if (isSurvey) {
      props.history.push("/SurveyLocation");
    } else if (isEligibleForEnhancedDiagnostics) {
      props.history.push("/RepairTradeCategory");
    } else {
      props.history.push("/RepairLocation");
    }
  };

  const checkPremisesEligibility = async (
    premisesId: any,
    tenancyGroup: any,
    assetType: any,
    isAssetVoid: boolean = false
  ) => {
    try {

      if (isSurvey) {
        dispatch(saveIsEligibleForEnhancedDiagnostics(false));
        setEligibilityWarningBoxStyle("none");
        setButtonDisable(false);
        return;
      }

      setButtonDisable(true);
      let responsePremisesEligibility = null;
      const currentAssetCachedEligibilityOutcome = subSessionAssetsEligibilityDetailsRedux?.find((assetEligDetailEle: any) => assetEligDetailEle.assetId === premisesId);
      if (!isNullOrUndefined(currentAssetCachedEligibilityOutcome)) {
        responsePremisesEligibility = currentAssetCachedEligibilityOutcome.assetEligibilityResponse;
      }
      else {
        const responsePremisesEligibilityResp = await api.postPremisesEligibility(
          premisesId,
          tenancyGroup
        );

        if (responsePremisesEligibilityResp?.length > 0) {
          responsePremisesEligibility = responsePremisesEligibilityResp[0];
          const assetTypeId = Number.parseInt(PremisesTypeId[assetType]);
          const hasParentPresent = selectedAssets?.filter((x: any) => {
            const associatedTypeId = Number.parseInt(PremisesTypeId[x.assetType]);
            return associatedTypeId < assetTypeId;
          });
          const hasParent = hasParentPresent?.length > 0 ? true : false;
          const matchBR12BR13 = (responsePremisesEligibility?.errorCode === "E4" && assetType !== "Property") || responsePremisesEligibility?.errorCode === "E24";
          let assetEligibilityForRaiseRepair = {
            assetId: premisesId,
            assetEligibilityResponse: responsePremisesEligibility,

            // We want to stop scenario when asset matches BR 12 & BR13 and is capable of skipping Repair Asset page
            isEligibleToRaiseARepair: !responsePremisesEligibility?.isEligible && !hasParent && matchBR12BR13 ? false : true
          }
          let assetEligibilityDetailsCache = subSessionAssetsEligibilityDetailsRedux ?? [];
          assetEligibilityDetailsCache.push(assetEligibilityForRaiseRepair);
          dispatch(saveSubSessionAssetsEligibilityDetails(assetEligibilityDetailsCache));
          dispatch(saveCurrentAssetEligibilityDetails(assetEligibilityForRaiseRepair));
        }
      }


      eligiblityForEnhancedDiagnostics =
        isEnhancedDiagnosticsEnabled &&
        accessEnhancedRepairDiagnostics &&
        (isAssetVoid || responsePremisesEligibility?.isEligible) &&
        responsePremisesEligibility?.maintenanceResponsibilityGroup?.toUpperCase() !==
        Helper.MaintenanceResponsibilityGroup.PartiallyPeabody?.toUpperCase();

      if (eligiblityForEnhancedDiagnostics && isNullOrUndefined(plentificRepairDiagnosticsHealth)) {
        try {
          const healthResp = await api.getRepairDiagnosticsHealthCheck();
          const plentificHealth = healthResp?.status === "Healthy";
          setPlentificRepairDiagnosticsHealth(plentificHealth);
          eligiblityForEnhancedDiagnostics = plentificHealth;
        } catch (e) {
          console.error("Enhanced Diagnostics API Health Check Error:", e);
          eligiblityForEnhancedDiagnostics = false;
        }
      } else {
        eligiblityForEnhancedDiagnostics = eligiblityForEnhancedDiagnostics && (plentificRepairDiagnosticsHealth ?? false);
      }



      dispatch(
        saveIsEligibleForEnhancedDiagnostics(eligiblityForEnhancedDiagnostics)
      );

      const supplimentaryCodes =
        responsePremisesEligibility?.supplimentaryCodes || '';

      dispatch(saveSupplimentaryCodes(supplimentaryCodes));

      const supplimentaryCodesArray = !isUndefinedNullOrEmpty(
        supplimentaryCodes
      )
        ? supplimentaryCodes?.split(',').map((code: string) => code.trim())
        : [];

      let mappedSuppErrCodes: any = [];
      if (supplimentaryCodesArray && supplimentaryCodesArray.length > 0) {
        supplimentaryCodesArray?.forEach((item: any) => {
          if (i18n?.exists(item)) {
            mappedSuppErrCodes.push(item);
          }
        });
      }
      setSupplimentaryAlert(mappedSuppErrCodes);

      if (isAssetVoid) {
        // All Void assets are allowed to raise repairs
        // Logic for validating eligibility to be moved to Drools in later implementation
        setEligibilityWarningBoxStyle(supplimentaryCodesArray?.length > 0 ? "block" : "none");
        setButtonDisable(false);
        return { isPremisesEligile: true, errorCode: "" };
      }
      let errorCode = responsePremisesEligibility?.errorCode;
      if (
        errorCode === "E1" ||
        errorCode === "E4" ||
        errorCode === "E24" ||
        errorCode === "E5"
      ) {
        setErrorCode(errorCode);
        // Show purple alert if Section 8, else show red alert
        setEligibilityWarningBoxStyle("block");
        if (
          tenancyGroup === "LEASEHOLD" ||
          tenancyGroup === "FREEHOLD" ||
          tenancyGroup === "AGENT"
        ) {
          errorCode = t(errorCode) + tenancyGroup;
          setErrorCode(errorCode);
          setEligibilityWarningBoxStyle("block");
        } else if (errorCode === "E1" || errorCode === "E4") {
          let tempError;
          tempError = t(errorCode).replace("@tenancyGroup", tenancyGroup);
          let tempArray = tempError.split("?");
          setErrorCodeArray(tempArray);
        } else if (errorCode === "E5") {
          errorCode = t(errorCode);
          let tempError;
          tempError = t(errorCode);
          let tempArray_1 = tempError.split("?");
          setErrorCodeArray(tempArray_1);
        }
      } else {
        setErrorCode(responsePremisesEligibility?.errorCode);
        if (!responsePremisesEligibility?.isEligible) {
          setEligibilityWarningBoxStyle("block");
        } else {
          setEligibilityWarningBoxStyle(supplimentaryCodesArray?.length > 0 ? "block" : "none");
          setButtonDisable(false);
        }
      }

    } catch (e) {
      setTimeout(() => setIsLoading(false), 300);
      SetRepairSectionUnavailable();
      console.error(e);
    }
  };


  const GetTenancyGroup = async (customerID: any, premisesId: any, getAssetByIdResponse: any) => {
    let tenencyGroup = "";
    let assetStatus = getAssetByIdResponse.assetStatus,
      uprn = getAssetByIdResponse.uprn;
    if (customerID && assetStatus === Helper.AssetStatuses.Occupied) {
      const responseTenancyGroup = await api.getTenanciesGroup(
        customerID,
        premisesId
      );

      if (isNullOrUndefined(responseTenancyGroup) || responseTenancyGroup?.length < 1) {
        SetRepairSectionUnavailable();
        return;
      }
      let tenancyId = "";
      if (Array.isArray(customerTenancy) && uprn) {
        const currentTenancy = customerTenancy.find((t: any) => t?.tenancySummary?.uprn === uprn);
        tenancyId = currentTenancy?.tenancySummary?.tenancyId ?? "";
      }
      if (tenancyId) {
        const currentTenancyGroup = responseTenancyGroup.find((t: any) => t?.tenancyIdentifier === tenancyId);
        tenencyGroup = currentTenancyGroup?.tenancyGroup ?? "";
      }
      if (!tenencyGroup || tenencyGroup === "") {
        tenencyGroup = responseTenancyGroup[0]?.tenancyGroup;
      }
      dispatch(selectedTenancyGroup(tenencyGroup));
      return tenencyGroup;
    }

    return;
  };

  const checkAndSetAssetDetailsForNextStep = async (
    assetType: string,
    assetId: string,
    uprn: string,
    address: string
  ) => {
    setButtonDisable(true);

    setAssetTypeValue(assetType);
    dispatch(selectedTenacyType(assetType));
    setPropertyIdChosen(assetId);
    dispatch(userChosenPropertyAddress(address));
    dispatch(defaultAssetId(assetId));
    dispatch(
      updateDashboardForm({
        assetType,
        assetId,
        customerID,
      })
    );

    // Getting parent asset type here    
    const getNextAssetId = (assetId: string) => {
      if (!Array.isArray(addressesData)) return null;
      // Flatten addressesData if it's an array of arrays
      const flatAddresses = Array.isArray(addressesData[0])
        ? addressesData.flat()
        : addressesData;
      const idx = flatAddresses.findIndex((item: any) => item.id === assetId);
      if (idx === -1) return null;
      // Find the next asset that is not a "Block"
      for (let i = idx + 1; i < flatAddresses.length; i++) {
        if (flatAddresses[i].assetType !== "Divided Block") {
          return flatAddresses[i].assetType;
        }
      }
      return null;
    };

    const nextAssetType = getNextAssetId(assetId);

    const getAssetByIdResp = await api.getAssetsByid(assetId);
    dispatch(assetByIdDataObject(getAssetByIdResp));
    // Dispatching asset sub type and asset parent type
    dispatch(saveAssetSubTypeData(getAssetByIdResp.assetSubType))
    dispatch(saveParentAssetTypeData(nextAssetType));
    const tenancyTypeGroup = await GetTenancyGroup(customerID, assetId, getAssetByIdResp);
    const isAssetVoid = getAssetByIdResp?.assetStatus === Helper.AssetStatuses.Void;
    await checkPremisesEligibility(assetId, tenancyTypeGroup ?? "", getAssetByIdResp?.assetType, isAssetVoid);
    return;
  };

  const updateSelection = async (
    assetType: string,
    assetId: string,
    uprn: string,
    address: string
  ) => {
    try {
      setIsLoading(true);
      if (backToRepair && isResumeDraftRepair && workOrderObject?.premisesId !== assetId) {
        dispatch(workOrderRepairObject(null));
        dispatch(resumeDraftRepair(false));
        dispatch(userResumeDraftDataCache(null));
      }
      if (EditState === true) {
        if (!IsRecall) {
          dispatch(userChosenRepairLocationId(0));
          dispatch(userChosenHighLevelDescription(""));
          dispatch(userChosenVandalismAdditionalInformation(""));
          dispatch(userChosenVandalismQuestion("No"));
          dispatch(userChosenAdditionalDescription(""));
        }
        dispatch(userChosenCovidQuestion(""));
        dispatch(userChosenVulnerabilityAdditionalInformation(""));
        dispatch(userChosenVulnerabilityQuestion("No"));
        dispatch(userChosenContactDetails(""));
        dispatch(userChosenContactPhone(""));
        dispatch(userChosenContactName(""));
        dispatch(userChosenRelationDetails(""));
        dispatch(userChosenEmergencyQuestion(""));
        dispatch(userChosenPropertyId(""));
        dispatch(isEditState(false));

        dispatch(userChosenDuplicateQuestion(""));
      }
      dispatch(userTypedRepairReasons(""));
      setPropertyIdChosen(assetId);
      return await checkAndSetAssetDetailsForNextStep(assetType, assetId, uprn, address);
    }
    catch (e) {
      console.error("Repair Asset - update selection:", e);
    }
    finally {
      if (loadingTimeoutRef.current) clearTimeout(loadingTimeoutRef.current);
      loadingTimeoutRef.current = setTimeout(() => setIsLoading(false), 300);
    }
  };

  let _className = "card-body1 bg-grey shadow-lg1 rounded-lg";
  let fieldsArray: any[] = [];
  addresses?.forEach((element: any) => {
    element?.length > 0 &&
      element.forEach((item: any) => {
        if (item.assetType !== "Scheme" && item.assetType !== "Estate Area") {
          _className =
            item.assetType === assetTypeValue && item.id === propertyIdChosen
              ? "border-purple-100 card-body1 bg-grey shadow-lg1 rounded-lg min-ht"
              : "card-body1 bg-grey shadow-lg1 rounded-lg min-ht";
          fieldsArray.push(
            <div
              data-testid={item.assetType}
              className="mb-4 asset-panels margin-rt gap-4 mb-4 asset-panel border bg-grey shadow-lg rounded-lg"
              id={"repair-asset-main-div" + item.id}
            >
              {isRecallValue ? (
                <div data-testid="update-select1">
                  <div
                    className="card-margin-new"
                    id={"repair-asset-div1" + item.id}
                  >
                    <div
                      className={_className}
                      id={"repair-asset-div2" + item.id}
                    >
                      <div
                        className="d-flex px-6 py-2 bg-peach rounded-t-lg flex items-center bg-peach-radius card-title-height"
                        id={"repair-asset-div3" + item.id}
                      >
                        <div
                          className="ic-user-new flex"
                          id={"repair-asset-div4" + item.id}
                        >
                          <img
                            src={Helper.getAssetIcon(item.assetType)}
                            alt=""
                            className="me-2 my-0 text-lg"
                          ></img>
                        </div>
                        <h2 className="card-text my-0 text-lg" id={item.id}>
                          {/* @ts-ignore */}
                          {Helper.BlockMap[item.assetType]}
                        </h2>
                      </div>
                      <p
                        className="card-text px-6 pt-3 global-txt m-0"
                        id={"repair-asset-p" + item.id}
                      >
                        {item.addresses?.postalAddresses[0]?.formattedAddress
                          .split(",")
                          .map((step: any, i: number) => (
                            <>
                              {i === 0 ? (
                                <strong className="py-2 my-2">{step}</strong>
                              ) : (
                                <p className="py-0 my-0">{step}</p>
                              )}
                              {"\n "}
                            </>
                          ))}
                      </p>
                    </div>
                  </div>
                </div>
              ) : (
                <div
                  data-testid="update-select"
                  onClick={() => {
                    updateSelection(
                      item.assetType,
                      item.id,
                      item.uprn,
                      item.addresses?.postalAddresses[0]?.formattedAddress
                    );
                  }}
                >
                  <div
                    className="card-margin-new"
                    id={"repair-asset-div1" + item.id}
                  >
                    <div
                      className={_className}
                      id={"repair-asset-div2" + item.id}
                    >
                      <div
                        className="d-flex px-6 py-2 bg-peach rounded-t-lg flex items-center bg-peach-radius card-title-height"
                        id={"repair-asset-div3" + item.id}
                      >
                        <div
                          className="ic-user-new flex"
                          id={"repair-asset-div4" + item.id}
                        >
                          <img
                            src={Helper.getAssetIcon(item.assetType)}
                            alt=""
                            className="me-2 my-0 text-lg"
                          ></img>
                        </div>
                        <h2 className="card-text my-0 text-lg" id={item.id}>
                          {/* @ts-ignore */}
                          {Helper.BlockMap[item.assetType]}
                        </h2>
                      </div>
                      <p
                        className="card-text px-6 pt-3 global-txt m-0"
                        id={"repair-asset-p" + item.id}
                      >
                        {item.addresses?.postalAddresses[0]?.formattedAddress
                          .split(",")
                          .map((step: any, i: number) => (
                            <>
                              {i === 0 ? (
                                <strong className="py-2 my-2">{step}</strong>
                              ) : (
                                <p className="py-0 my-0">{step}</p>
                              )}
                              {"\n "}
                            </>
                          ))}
                      </p>
                    </div>
                  </div>
                </div>
              )}
            </div>
          );
        }
      });
  });

  return (
    <Container id="back-modal-container" role="main" className="ctn-fht">
      <div
        id="ReapirAsset-back-div"
        className="container mx-auto mb-0 md:mb-14 lg:mb-10 px-0 xl:px-0"
      >
        <div className="back-and-journey">
          <p id="ReapirAsset-p" className="text-teal text-xl mt-2 mb-8">
            <Button
              className="back-btn"
              data-testid="backButtonHandler"
              onClick={backButtonHandler}
            >
              <i className="fas fa-angle-left mr-2"></i>
              {t("back")}
            </Button>
          </p>
          <div className=""></div>
          {<RepairJourney />}
        </div>
      </div>

      {isLoading ? (
        <LoadingSpinner />
      ) : (
        <>
          <div className="container mt-4">
            <div id="repair-asset-divs" className="mb-4 repair-text">
              {isSurvey ? (
                <h2
                  id="repair-asset-h2"
                  className="text-purple-100 text-2xl mb-8 global-txt"
                >
                  {t("survey_report_label")}
                </h2>
              ) : (
                <h2
                  id="repair-asset-h1"
                  className="text-purple-100 text-2xl mb-8 global-txt"
                >
                  {t("repair_report_label")}
                </h2>
              )}
            </div>
            <div className="lg:min-h-80">
              <div
                className="asset-panels grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4 md:gap-8 mb-4 "
                id="options"
              >
                {fieldsArray}
              </div>
            </div>
          </div>

          <div
            style={{ display: eligibilityWarningBoxStyle }}
            className="warning mb-8"
            role="alert"
            id="repair-asset-alert"
            data-testid="suppCode_alert"
          >
            {errorCode &&
              <div className="w-full px-4 py-2 bg-red-20 flex items-center">
                <div className="px-4 pr-8">
                  <i className="fas fa-exclamation-circle me-2 text-brick-100 w-6 h-6 bolder-font"></i>
                </div>
                <div className="flex items-center text-black">
                  {errorCode !== "E1" &&
                    errorCode !== "E4" &&
                    errorCode !== "E5" ? (
                    <p className="w-full text-left my-2 font-AvantGardeGothic-Md">
                      {t(errorCode)}
                    </p>
                  ) : (
                    <p className="w-full text-left my-2 font-AvantGardeGothic-Md">
                      {errorCode === "E1" ? (
                        <>
                          {errorCodeArray[0]}
                          <ul>
                            <li> {errorCodeArray[1]}</li>
                            <li> {errorCodeArray[2]}</li>
                          </ul>
                        </>
                      ) : (
                        <>
                          {errorCodeArray[0]}
                          <ul>
                            <li> {errorCodeArray[1]}</li>
                          </ul>
                        </>
                      )}
                    </p>
                  )}
                </div>
              </div>
            }

            {
              supplimentaryAlert?.map((alert: any) => {
                return (
                  alert && <div className="w-full px-4 py-2 bg-purple-20 flex items-center">
                    <div className="px-4 pr-8">
                      <i className="fas fa-bullhorn me-2 text-purple-100 w-6 h-6 bolder-font purple-icon"></i>
                    </div>
                    <div className="flex items-center text-black">
                      <p className="w-full text-left my-2 font-AvantGardeGothic-Md">
                        {t(alert)}
                      </p>
                    </div>
                  </div>
                )
              })}
          </div>
        </>
      )}

      {!isLoading && (
        <div
          className="flex justify-between items-center pb-4 md:pb-8 container"
          id="repair-asset-btn"
        >
          <ExitModalContent
            id="repair-asset-exitmodal"
            exit={exitButtonHandler}
          />
          <Button
            id="btn_repairasset"
            disabled={buttondisable}
            onClick={callPageHandler}
            className="button-class"
          >
            {t("continue")}{" "}
            <i className="fas fa-angle-right relativetext-white pointer-events-none arrow"></i>
          </Button>
        </div>
      )}
    </Container>
  );
};
export default RepairAsset;
